<template>
    <div :class="{ 'card' : !isOnlyContent }">
        <div
            class="d-none"
            :class="{ 'd-block card-header' : !isOnlyContent }">
            <div class="d-flex align-items-center justify-content-between">
                <div class="font-weight-bold">{{ $locale.question }}</div>
                <b-button
                    @click="isShow = true"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : isShow }">
                    開く
                </b-button>
                <b-button
                    @click="isShow = false"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : ! isShow }">
                    閉じる
                </b-button>
            </div>
        </div>

        <div
            class="card-body mt-2"
            :class="{ 'd-none' : !isShow }">
            <div :class="{ 'c-box-scroll' : !isOnlyContent, 'c-box-scroll--300' : !isOnlyContent && isShow }">
                <div
                    v-if="Number(flgReservedByDoctor) === 1"
                    class="mb-4 small">
                    ※医師による予約
                </div>
                <dl v-if="hasCommonAnswer">
                    <template v-for="answer in prefixCommonAnswers">
                        <dt>{{ answer.title }}</dt>
                        <dd class="u-mb3 pre-wrap">{{ answer.content || '-' }}</dd>
                    </template>
                    <template v-for="answer in interviewAnswers">
                        <dt>{{ answer.title }}</dt>
                        <dd class="u-mb3 pre-wrap">{{ answer.content || '-' }}</dd>
                    </template>
                    <template v-for="answer in suffixCommonAnswers">
                        <dt>{{ answer.title }}</dt>
                        <dd class="u-mb3 pre-wrap">{{ answer.content || '-' }}</dd>
                    </template>
                </dl>
                <dl v-else-if="hasMatchingAnswer">
                    <template v-for="answer in interviewMatchingAnswers">
                        <dt>{{ answer.title }}</dt>
                        <dd class="u-mb3 pre-wrap">{{ answer.content || '-' }}</dd>
                    </template>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: {
            dataAnswers: {
                type: Array,
                default: null,
            },
            dataMatchingAnswers: {
                type: Array,
                default: null,
            },
            dataCommonAnswers: {
                type: Array,
                default: null,
            },
            consultationId: {
                type: Number,
                default: null,
            },
            isOnlyContent: {
                default: 0,
            },
            flgReservedByDoctor: {
                default: 0,
            },
        },

        data: function() {
            return {
                isShow: true,
                interviewMatchingAnswers: null,
                interviewCommonAnswers: null,
                interviewAnswers: null,
            }
        },

        computed: {
            /**
             * デフォルト問診の回答リスト（先頭表示）
             *
             * @return array
             */
            prefixCommonAnswers: function () {
                if (!this.interviewCommonAnswers) return []
                return this.interviewCommonAnswers.filter((answer) => answer.display_type === 'prefix')
            },

            /**
             * デフォルト問診の回答リスト（末尾表示）
             *
             * @return array
             */
            suffixCommonAnswers: function () {
                if (!this.interviewCommonAnswers) return []
                return this.interviewCommonAnswers.filter((answer) => answer.display_type === 'suffix')
            },

            hasCommonAnswer: function () {
                return (this.interviewCommonAnswers && this.interviewCommonAnswers.length > 0)
                    || (this.interviewAnswers && this.interviewAnswers.length > 0)
            },

            hasMatchingAnswer: function () {
                return this.interviewMatchingAnswers && this.interviewMatchingAnswers.length > 0
            },
        },

        created: function() {
            if (this.consultationId) {
                this.fetchInterviewAnswers()
            }
            else {
                this.interviewMatchingAnswers = this.dataMatchingAnswers
                this.interviewCommonAnswers = this.dataCommonAnswers
                this.interviewAnswers = this.dataAnswers
            }
        },

        methods: {
            /**
             * 問診回答一覧
             */
            fetchInterviewAnswers: async function () {
                const endpoint = `${constants.admin.consultations.endpoint.base}/${this.consultationId}/answers`

                await axios.get(`${endpoint}/matching`)
                    .then(({data}) => {
                        this.interviewMatchingAnswers = data
                    })
                await axios.get(`${endpoint}/common`)
                    .then(({data}) => {
                        this.interviewCommonAnswers = data
                    })
                await axios.get(endpoint)
                    .then(({data}) => {
                        this.interviewAnswers = data
                    })

                this.isShow = this.hasCommonAnswer || this.hasMatchingAnswer
            },
        },
    }
</script>

<style scoped lang="scss">
.pre-wrap {
    white-space: pre-wrap;
}
</style>
